// extracted by mini-css-extract-plugin
export default {"invalid-error":"PoolForm_invalid-error__ZiQ3E","submitBtn":"PoolForm_submitBtn__6rld8"};